module.exports = __webpack_public_path__ + "img/empty-sommelier-red.061cfd8.svg";